import { AppFilterType, FilterItem } from "@/components/filter/filter.types.ts";
import { useAppFilterEmployeeRenders } from "@/components/filter/renders/filter-employee-renders.tsx";
import { UseFilterActiveFilter } from "@/components/filter/use-filter.hook.tsx";
import { setFilterParam } from "@/pages/reporting/employee/people-analytics/people-analytics.types.ts";
import { ApiPeopleAnalyticsEmployeeFilter } from "@/types/reporting/people-analytics.types.ts";
import { Button, Modal, ModalProps, useModals } from "@skailer-com/uikit";
import { Control, FieldErrors, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

interface FilterValueModalProps extends ModalProps {
  field: FilterItem;
  label: string;
  currentFilter: UseFilterActiveFilter<ApiPeopleAnalyticsEmployeeFilter>;
  filters: FilterItem[];
}

export function FilterValueModal({
  field,
  label,
  currentFilter,
  filters,
  ...props
}: FilterValueModalProps) {
  const { t } = useTranslation();
  const { close } = useModals();
  const [, setSearchParams] = useSearchParams();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<ApiPeopleAnalyticsEmployeeFilter>({ values: currentFilter.filter });

  const renders = useAppFilterEmployeeRenders({
    control: control as Control,
    typedFilters: currentFilter.typedFilters,
    errors: errors as FieldErrors,
    filters,
  });

  const renderField = () => {
    switch (field.type) {
      case AppFilterType.employeeTeam:
        return renders.renderFilterTeams(field);
      default:
        return null;
    }
  };

  const onApply = handleSubmit((values) => {
    setSearchParams(
      (current) => {
        const next = new URLSearchParams(current);
        const raw = (values as Record<string, unknown>)[field.name];
        const list = Array.isArray(raw) ? (raw as (string | number)[]) : undefined;
        setFilterParam(next, field.name, list);
        return next;
      },
      { replace: true }
    );
    close(props.id);
  });

  return (
    <Modal
      {...props}
      variant="middle"
      size="md"
      title={t("reporting:people_analytics_filter_by", { name: label })}
      withCloser
      closeByEscEnabled
      actions={
        <Button size="lg" className="w-full" type="submit" onClick={onApply}>
          {t("common:filter_apply")}
        </Button>
      }
    >
      <form onSubmit={onApply}>{renderField()}</form>
    </Modal>
  );
}
